import { useEffect, useState } from 'react';
import { useInstance } from '../../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { SavedChecklistsState } from '../../checklists/SavedChecklistsState.ts';
import { ISavedChecklist } from '../../checklists/model.ts';
import { ChecklistState } from '../../checklists/ChecklistState.ts';
import { AlertPresenter } from '../../app/AlertBinder.tsx';
import { HistoryViewModel } from '../../app/HistoryViewModel.ts';

export const useSavedChecklistState = (checklistId: string) => {

    const checklists = useInstance(SavedChecklistsState);
    useSubscription(() => checklists);

    const alert = useInstance(AlertPresenter);
    const history = useInstance(HistoryViewModel);

    const [checklist, setChecklist] = useState<ChecklistState<ISavedChecklist>>();

    useEffect(() => {
        checklists.getChecklistById(checklistId).then(setChecklist)
            .catch((e: any) => {
                if (e.errorCode === 'checklist.not-found') {
                    alert.showAlert({
                        header: 'Checklist Not Found',
                        message: `Sorry, the checklist you tried to view does not exist, or has been deleted.`
                    });
                    history.back('/checklists');
                } else {
                    alert.showAndLogError(e);
                }
            });
    }, [checklistId, checklists, alert, history]);

    return checklist;
};
